<div id="collagedesigner3-content" *ngIf="config && isInitialized">
  <design-step></design-step>
</div>



// WEBPACK FOOTER //
// ./src/app/collage-designer/collage-designer.component.html